import { FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { Calendar, MapPin } from "lucide-react";

interface ClienteleStepProps {
  form: UseFormReturn<any>;
}

const ClienteleStep = ({ form }: ClienteleStepProps) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold flex items-center gap-2">
          <Calendar className="w-6 h-6 text-primary" />
          Clientela e Operatività
        </h2>
        <p className="text-muted-foreground">Informazioni sui tuoi orari e sulla tua area di servizio</p>
      </div>

      <FormField
        control={form.control}
        name="openingHours"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Giorni e Orari di Apertura - Specifica tutti i giorni della settimana e relativi orari *</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Es. Lunedì-Venerdì 9:00-19:00, Sabato 9:00-13:00"
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="clientRadius"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              Raggio Clientela - Da quale raggio medio provengono i tuoi clienti o vorresti acquisirne di nuovi? *
            </FormLabel>
            <FormControl>
              <Input
                placeholder="Es. 10 km / Provincia di Milano / Regione Lombardia"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default ClienteleStep;
